export default __webpack_public_path__ + "static/web-cms-16b7941c08422f4693fdefdedc5a30f7.svg";